import React from 'react';
import DiscussionMessagesComponent from '../DiscussionMessages';
import { Box, Hidden } from '@material-ui/core';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import DiscussionsList from '../DiscussionsList';
import useStyles from './styles';
import { useGetAllMessageUnseen } from '../../hooks/queries/useGetAllMessageUnseen';
import DiscussionFilterProvider from '../../providers/DiscussionFilterProvider';

const Discussions = () => {
  const { path } = useRouteMatch();

  const classes = useStyles();

  useGetAllMessageUnseen();

  return (
    <DiscussionFilterProvider>
      <Box className={classes.wrapper}>
        <Hidden smDown>
          <Route
            path={`${path}/:id?`}
            render={(_) => (
              <DiscussionsList discussionId={+_.match.params.id} />
            )}
          />
          <Switch>
            <Route
              path={`${path}/:id`}
              render={(_) => (
                <DiscussionMessagesComponent
                  discussionId={+_.match.params.id}
                />
              )}
            />
          </Switch>
        </Hidden>
        <Hidden mdUp>
          <Switch>
            <Route exact path="/discussions" component={DiscussionsList} />
            <Route
              path={`${path}/:id`}
              render={(_) => (
                <DiscussionMessagesComponent
                  discussionId={+_.match.params.id}
                />
              )}
            />
          </Switch>
        </Hidden>
      </Box>
    </DiscussionFilterProvider>
  );
};

export default Discussions;
